import { Yii } from "libraries/interfaces/Yii";
import { ILabels } from "libraries/interfaces/ILabels";

export const WORDING: ILabels = {
    standardisationBody: Yii.t('wui-shared-js', 'Standard'),
    traveller: Yii.t('wui-shared-js', 'Voyageur'),
    referencedHotel: Yii.t('wui-shared-js', 'Hotels référencés'),
    brand: Yii.t('wui-shared-js', 'Marques'),
    child : Yii.t('wui-shared-js', 'Enfant'),
    infant : Yii.t('wui-shared-js', 'Bébé'),
    tags: Yii.t('wui-shared-js', 'Mots-clés'),
    isOnlyRefundable: Yii.t('wui-shared-js', 'Masquer les offres avec frais d\'annulation'),
};
